import React, { FC, useMemo, useRef, useState } from 'react';

import { Column, FilterRow, Pager, Paging } from 'devextreme-react/data-grid';

import { AppCard, AppLayoutTop } from 'components/appComponents';
import ClaimsProvider from 'components/claimsBlock';
import { Button, DataGrid } from 'devextreme-react';
import $createStore from 'utils/create-store-instance';

import { CreateEditModal, DeleteModal } from './components';

const TransportOverRate: FC = () => {
  const [modalIsVisible, setModalIsVisible] = useState(false);
  const [modalIsVisibleDelete, setModalIsVisibleDelete] = useState(false);
  const [detailId, setDetailId] = useState<number | null>(null);

  const requestDateSource = useMemo(() => {
    return $createStore('/v1/TransportOverRate', 'id');
  }, []);

  const refGrid = useRef<DataGrid | null>(null);

  const refresh = () => refGrid.current?.instance.refresh();

  return (
    <div className="container-dev">
      {modalIsVisible && (
        <CreateEditModal changeVisible={setModalIsVisible} visible={modalIsVisible} refresh={refresh} id={detailId} />
      )}
      {modalIsVisibleDelete && (
        <DeleteModal
          changeVisible={setModalIsVisibleDelete}
          visible={modalIsVisibleDelete}
          refresh={refresh}
          detailId={detailId}
          cashFlowId={detailId}
        />
      )}

      <AppLayoutTop title="Повышенная ставка транспорта">
        <ClaimsProvider claimsBlock={['CanCreateTransportOverRate']}>
          <Button width={120} text="Создать" type="default" onClick={() => setModalIsVisible(true)} />
        </ClaimsProvider>
      </AppLayoutTop>

      <AppCard>
        <DataGrid
          dataSource={requestDateSource as any}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
        >
          <FilterRow visible={true} />

          <Column dataField="transport" caption="Транспорт" />
          <Column dataField="model" caption="Модель" />
          <Column dataField="dateBegin" caption="Дата начала" dataType="date" />
          <Column dataField="dateEnd" caption="Дата окончания" dataType="date" />
          <Column dataField="overRateIgnoreMaterial" caption="Независимо от материала" />

          <Column
            dataField="actions"
            caption=""
            width={120}
            cellRender={(data) => (
              <>
                <ClaimsProvider claimsBlock={['CanEditTransportOverRate']}>
                  <Button
                    icon="edit"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setDetailId(data.data.id);
                      setModalIsVisible(true);
                    }}
                  />
                </ClaimsProvider>
                <ClaimsProvider claimsBlock={['CanDeleteTransportOverRate']}>
                  <Button
                    icon="trash"
                    type="default"
                    stylingMode="text"
                    onClick={() => {
                      setDetailId(data.data.id);
                      setModalIsVisibleDelete(true);
                    }}
                  />
                </ClaimsProvider>
              </>
            )}
          />

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default TransportOverRate;
